import React from "react";
import PropTypes from "prop-types";
import ComingSoon from "../../components/ComingSoon";

Landing.propTypes = {};

export default function Landing({}) {
  return <ComingSoon />;
}
